// these tokens are the 1:1 connection to the brand and theme settings
// from these tokens we will derive the variants necessary for full theming
// Not for consumer use
// Not for consumer use
// Deprecated color tokens - legacy tokens that should not be used
// System color tokens - internal system tokens that should not be overridden by consumers
// All available base color tokens
// All available reporting color tokens
// These arrays define which variants each token category supports
// Only AvailableTokens prefixes are permitted
export const NO_VARIANTS = [];
export const SINGLE_VARIANT = ['default'];
export const SUBTLE_VARIANT = ['default', 'subtle'];
export const HOVER_PRESSED_VARIANT = ['default', 'hover', 'pressed'];
export const COMPLETE_VARIANT = ['default', 'hover', 'pressed', 'subtle'];

// Extracts the prefix from token names (e.g., 'fill-brand-default' → 'fill-brand').
// Only handles -default and -subtle because those are the only suffixes in AvailableTokens.
// Variants like -hover and -pressed are derived automatically and not directly targetable.
// We can't rely solely on default because there are some reporting tokens who only have a subtle variant
// without a companion default variant.
// Defines which variants each token prefix supports and optional derived tokens.
export const TOKEN_VARIANT_CONFIGS = [{
  prefixes: ['reporting-fill-chart-alert', 'reporting-fill-chart-caution', 'reporting-fill-chart-positive', 'reporting-fill-chart-white'],
  variants: NO_VARIANTS
}, {
  prefixes: ['icon-accent-blue', 'icon-accent-green', 'icon-accent-magenta', 'icon-accent-orange', 'icon-accent-purple', 'icon-accent-red', 'icon-accent-teal', 'icon-accent-yellow'],
  variants: SINGLE_VARIANT
}, {
  prefixes: ['border-accent-blue', 'border-accent-light-orange', 'border-accent-magenta', 'border-accent-orange', 'border-accent-purple', 'border-accent-red', 'border-accent-yellow'],
  variants: SINGLE_VARIANT
}, {
  prefixes: ['border-container'],
  variants: SINGLE_VARIANT
}, {
  prefixes: ['reporting-fill-highlight-blue', 'reporting-fill-highlight-green', 'reporting-fill-highlight-orange', 'reporting-fill-highlight-purple', 'reporting-fill-highlight-red', 'reporting-fill-highlight-yellow'],
  variants: SUBTLE_VARIANT
}, {
  prefixes: ['icon-alert'],
  variants: HOVER_PRESSED_VARIANT
}, {
  prefixes: ['fill-accent-light-orange', 'fill-accent-magenta', 'fill-accent-orange', 'fill-accent-purple', 'fill-accent-teal'],
  variants: COMPLETE_VARIANT
}, {
  prefixes: ['fill-brand'],
  variants: COMPLETE_VARIANT,
  derivedTokens: {
    text: 'text-brand',
    border: 'border-brand',
    icon: 'icon-brand'
  }
}];

// Currently these constants and types are only used in the reference app's token explorer
// in order to keep the token explorer up to date with the latest tokens we are using within
// the theming system.
export const PORTALS_SURFACE_TOKENS = {
  'border-core-default': true,
  'border-core-disabled': true,
  'border-core-hover': true,
  'border-core-subtle': true,
  'border-transitional-core-subtle': true,
  'fill-accent-neutral-default': true,
  'fill-accent-neutral-hover': true,
  'fill-accent-neutral-pressed': true,
  'fill-accent-neutral-subtle': true,
  'fill-accent-neutral-subtle-alt': true,
  'fill-field-default': true,
  'fill-field-default-alt': true,
  'fill-field-disabled': true,
  'fill-field-hover': true,
  'fill-surface-default': true,
  'fill-surface-default-hover': true,
  'fill-surface-default-pressed': true,
  'fill-surface-raised': true,
  'fill-surface-recessed': true,
  'fill-surface-recessed-hover': true,
  'fill-surface-recessed-pressed': true,
  'icon-core-default': true,
  'icon-core-disabled': true,
  'icon-core-on-fill-default': true,
  'icon-core-subtle': true,
  'icon-interactive-default': true,
  'icon-interactive-disabled': true,
  'icon-interactive-hover': true,
  'icon-interactive-on-fill-default': true,
  'icon-interactive-on-fill-hover': true,
  'icon-interactive-on-fill-pressed': true,
  'icon-interactive-pressed': true,
  'icon-tertiary-default': true,
  'specialty-table-header-default': true,
  'specialty-table-header-hover': true,
  'specialty-table-header-pressed': true,
  'text-core-default': true,
  'text-core-disabled': true,
  'text-core-on-fill-default': true,
  'text-core-subtle': true,
  'text-interactive-default-disabled': true
};
export const PORTALS_PRIMARY_COLOR_TOKENS = {
  'fill-primary-default': true,
  'border-primary-default': true,
  'fill-primary-hover': true,
  'fill-primary-pressed': true,
  'fill-primary-disabled': true,
  'text-primary-default': true,
  'text-primary-disabled': true,
  'icon-primary-default': true
};
export const PORTALS_SECONDARY_COLOR_TOKENS = {
  'fill-secondary-default': true,
  'fill-secondary-default-alt': true,
  'fill-secondary-hover': true,
  'fill-secondary-hover-alt': true,
  'fill-secondary-pressed': true,
  'fill-secondary-pressed-alt': true,
  'fill-secondary-disabled': true,
  'fill-secondary-disabled-alt': true,
  'border-secondary-default': true,
  'border-secondary-default-alt': true,
  'text-secondary-default': true,
  'text-secondary-disabled': true
};
export const PORTALS_ACCENT_COLOR_ONE_TOKENS = {
  'fill-tertiary-default': true,
  'fill-tertiary-hover': true,
  'fill-tertiary-pressed': true,
  'fill-tertiary-disabled': true,
  'fill-transitional-tertiary-default': true,
  'fill-transitional-tertiary-hover': true,
  'fill-transitional-tertiary-pressed': true,
  'border-tertiary-default': true,
  'text-inverse-default': true,
  'text-tertiary-default': true,
  'fill-transitional-modal-gradient-color-1': true,
  'fill-transitional-modal-gradient-color-2': true,
  'icon-inverse-default': true,
  'text-tertiary-disabled': true
};
export const PORTALS_HEADING_FONT_TOKENS = {
  'heading-25': true,
  'heading-50': true,
  'heading-100': true,
  'heading-200': true,
  'heading-300': true,
  'heading-400': true,
  'heading-500': true,
  'heading-600': true,
  'heading-700': true,
  'heading-800': true,
  'heading-900': true,
  'heading-1000': true,
  'display-100': true,
  'display-200': true,
  'display-300': true,
  'display-400': true,
  'display-500': true
};
export const PORTALS_BODY_FONT_TOKENS = {
  'body-100': true,
  'body-125': true,
  'body-200': true,
  'body-300': true,
  'body-400': true,
  'body-500': true,
  'body-600': true,
  'body-700': true,
  'detail-100': true,
  'detail-200': true,
  'link-25': true,
  'link-100': true,
  'link-200': true
};